import { StoryQuestion, useStoryQuestion } from '@/components/microstory/question';
import { t } from '@lingui/macro';

export function MentalBurdensQuestion1() {
  const { selectedAnswer, handleAnswer } = useStoryQuestion();

  const answers = [
    {
      id: '1in2',
      label: t({ id: 'mental-burdens.question-1.answer-1', message: '1 in 2' }),
    },
    {
      id: '1in3',
      label: t({ id: 'mental-burdens.question-1.answer-2', message: '1 in 3' }),
    },
    {
      id: '1in4',
      label: t({ id: 'mental-burdens.question-1.answer-3', message: '1 in 4' }),
    },
    {
      id: '1in5',
      label: t({ id: 'mental-burdens.question-1.answer-4', message: '1 in 5' }),
    },
  ];

  return (
    <StoryQuestion
      question={t({
        message: `On average, what share of young people report feeling worried, anxious or nervous a lot?`,
        id: 'mental-burden.question-1.question',
      })}
      answers={answers}
      selectedAnswer={selectedAnswer}
      response={
        selectedAnswer?.id === '1in3'
          ? t({
              id: 'mental-burden.question-1.response-correct',
              message: 'Yes!',
            })
          : t({
              id: 'mental-burden.question-1.response-incorrect',
              message: 'Not quite!',
            })
      }
      onAnswer={handleAnswer}
    />
  );
}
